export const GET_BALANCE = 'GET_BALANCE';
export const GET_BALANCE_SUCCESS = 'GET_BALANCE_SUCCESS';
export const GET_BALANCE_FAILED = 'GET_BALANCE_FAILED';

export const CREATE_CONNECT_ACCOUNT = 'CREATE_CONNECT_ACCOUNT';
export const CREATE_CONNECT_ACCOUNT_SUCCESS = 'CREATE_CONNECT_ACCOUNT_SUCCESS';
export const CREATE_CONNECT_ACCOUNT_FAILED = 'CREATE_CONNECT_ACCOUNT_FAILED';

export const GENERATE_CONNECT_LINK = 'GENERATE_CONNECT_LINK';
export const GENERATE_CONNECT_LINK_SUCCESS = 'GENERATE_CONNECT_LINK_SUCCESS';
export const GENERATE_CONNECT_LINK_FAILED = 'GENERATE_CONNECT_LINK_FAILED';

export const GET_EXPRESS_LINK = 'GET_EXPRESS_LINK';
export const GET_EXPRESS_LINK_SUCCESS = 'GET_EXPRESS_LINK_SUCCESS';
export const GET_EXPRESS_LINK_FAILED = 'GET_EXPRESS_LINK_FAILED';

export const REDEEM_BALANCE = 'REDEEM_BALANCE';
export const REDEEM_BALANCE_SUCCESS = 'REDEEM_BALANCE_SUCCESS';
export const REDEEM_BALANCE_FAILED = 'REDEEM_BALANCE_FAILED';

export const REFUND_BALANCE = 'REFUND_BALANCE';
export const REFUND_BALANCE_SUCCESS = 'REFUND_BALANCE_SUCCESS';
export const REFUND_BALANCE_FAILED = 'REFUND_BALANCE_FAILED';

export const SEND_INVOICE = 'SEND_INVOICE';
export const SEND_INVOICE_SUCCESS = 'SEND_INVOICE_SUCCESS';
export const SEND_INVOICE_FAILED = 'SEND_INVOICE_FAILED';
